module.exports = __webpack_public_path__ + "media/assets/faria_products/GDPR-463804b05a915c6e4254fd2a861436822555d43beaefe7e7dea04c283c418f6c.svg";